<template>
  <a-menu-item-group class="menu-group" :key="item.name" :title="item.meta.title" v-if="item.children && item.children.length > 0">
    <slot></slot>
  </a-menu-item-group>
</template>

<script>
  export default {
    name: 'MenuGroup',
    components: {},
    props: {
      item: {
        type: Object,
        default() {
          return null
        },
      },
      routeChildren: {
        type: Object,
        default() {
          return null
        },
      },
    },
    methods: {},
  }
</script>

<style lang="scss">
  .ant-menu-item-group {
    .ant-menu-item-group-title {
      font-size: 13px;
      color: #999999;
    }
  }
  .ant-menu-item-group + .ant-menu-item-group {
    margin-top: 20px;
  }
</style>
